import { render, staticRenderFns } from "./CancelDispatchModal.vue?vue&type=template&id=dcddc468&scoped=true"
import script from "./CancelDispatchModal.vue?vue&type=script&lang=js"
export * from "./CancelDispatchModal.vue?vue&type=script&lang=js"
import style0 from "./CancelDispatchModal.vue?vue&type=style&index=0&id=dcddc468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcddc468",
  null
  
)

export default component.exports